import script from "./AnimalResultPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimalResultPage.vue?vue&type=script&setup=true&lang=js"

import "./AnimalResultPage.vue?vue&type=style&index=0&id=793c69b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-793c69b1"]])

export default __exports__